import request from '@/services/interceptor.js'

export const get_tipiScadenzaMezzo = () => {
    return request({
        url: '/tiposcadenzamezzo',
        method: 'get',
        loadingBar: true
    })
}

export const get_tipoScadenzaMezzo = (id) => {
    return request({
        url: `/tiposcadenzamezzo/${id}`,
        method: 'get',
        loadingBar: true
    })
}

export const create_tipoScadenzaMezzo = (par) => {
    return request({
        url: '/tiposcadenzamezzo',
        method: 'post',
        data: par,
        loadingBar: true
    })
}

export const update_tipoScadenzaMezzo = (id, par) => {
    return request({
        url: `/tiposcadenzamezzo/${id}`,
        method: 'put',
        data: par,
        loadingBar: true
    })
}

export const duplica_tipoScadenzaMezzo = (id) => {
    return request({
        url: `/tiposcadenzamezzo/${id}/duplica`,
        method: 'post',
        loadingBar: true
    })
}

export const delete_tipoScadenzaMezzo = (id) => {
    return request({
        url: `/tiposcadenzamezzo/${id}`,
        method: 'delete',
        loadingBar: true
    })
}
